<template>
    <div class="Header-container" :style="'background-color:' + backgroundColor">
        <div class="Header">
            <img class="logo" src="../../public/imgs/logo.png" alt="" @click="clickLogo">
            <ul class="navs">
                <li class="nav" :class="{active: activeIndex=='Home' || activeIndex == '/'}" @click="handleSelect('Home','Home')">首页</li>
                <li class="nav" :class="{active: activeIndex=='Introduct'}" @click="handleSelect('Introduct','Introduct')">产品介绍</li>
                <li class="nav" :class="{active: activeIndex=='Contact'}" @click="handleSelect('Contact','Contact')">联系我们</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'Header',
        props: ['backgroundColor'],
        computed: {
            ...mapState({
                activeIndex: state => state.activeIndex
            }),
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key,keyPath,this.activeIndex)
                if (this.activeIndex != key) {
                    this.$store.commit('changeNavs', key)
                    this.$router.push({name: keyPath})
                }
            },
            clickLogo() {
                this.$store.commit('changeNavs', 'Home')
                this.$router.push({name: 'Home'})
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" type="text/less">
    .Header-container {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 99;

        .Header {
            width: 1150px;
            margin: 0 auto;
            display: flex;

            .logo {
                width: 93.75px;
                height: 26.25px;
                padding: 17px 0;
                cursor: pointer;
            }

            .navs {
                list-style: none;
                margin-left: 140px;

                .nav {
                    color: #fff;
                    float: left;
                    font-size: 16px;
                    padding: 20px 10px;
                    margin: 0 15px;
                    cursor: pointer;
                    &.active {
                        border-bottom: 2px solid #fff;
                    }
                }
            }
        }
    }
</style>
